//querystring with switch_country, assign the preference
const urlParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlParams.entries());
if(params['switch_country']){
    localStorage.setItem('prefer-region', 'hk:'+Date.now());      
}

//check region
const storeNameMap = new Map([
    ['hk', 'Hong Kong'],
    ['sg', 'Singapore'],
    ['jp', 'Japan'],
    ['test-hk', 'Hong Kong (Testing)'],
    ['us', 'United State'],
    ['gb', 'United Kingdom']
]);

const preferenceLife = 30*60*1000;
const checkRegion = async () =>{
    const response = await fetch("https://region.bbr-offer.asia/hk/match.json", {credentials: 'include', method:'POST'});
    const {target, ipcountry} = await response.json();
    console.log(target, ipcountry);
    if(target === ipcountry) return; //same region

    const shopName = storeNameMap.get(ipcountry);
    if(!shopName)return;

    const preferRegion = localStorage.getItem('prefer-region') || "";
    const preferTime = parseInt(preferRegion.split(":")[1] || "0");
    const prefer = ((Date.now() - preferTime) > preferenceLife) ? "" : preferRegion.split(":")[0];
    if(target === prefer) return; //same prefer region;

    if(prefer === "suggest"){
    window.location.href = 'https://region.bbr-offer.asia/suggest';
    return;
    }

    document.querySelector('#region-popup').classList.add('active');
    if(shopName){
    document.querySelector('#suggest-link span').innerHTML = shopName;
    document.querySelector('#suggest-link').classList.add('active');        
    }

    document.querySelector('#region-confirm-btn').addEventListener('click', evt =>{
        localStorage.setItem('prefer-region', target + ":" + Date.now());
    });

    document.querySelector('#suggest-link').addEventListener('click', evt =>{
    evt.preventDefault();
    localStorage.setItem('prefer-region', "suggest:" + Date.now());
    window.location.href = 'https://region.bbr-offer.asia/suggest';
    })
}

//checkRegion().then();

const retainRegion = () => {
    const preferRegion = localStorage.getItem('prefer-region');
    if(!preferRegion)return;

    const preferTime = parseInt(preferRegion.split(":")[1] || "0");
    if((Date.now() - preferTime) > preferenceLife){
    //expired
    localStorage.removeItem('prefer-region');
    return;
    }
    
    const prefer = preferRegion.split(":")[0];
    localStorage.setItem('prefer-region', prefer + ":" + Date.now());
}
//retainRegion();